import { io, type Socket } from 'socket.io-client';

let _socket: Socket | null = null;

export function getSocket(): Socket {
  if (!_socket) {
    _socket = io('/events', {
      autoConnect:     false,
      transports:      ['websocket', 'polling'],
      reconnection:    true,
      reconnectionDelay: 2000,
    });
  }
  return _socket;
}

export function connectSocket(token: string): void {
  const socket = getSocket();
  socket.auth = { token };
  if (!socket.connected) socket.connect();
}

export function disconnectSocket(): void {
  _socket?.disconnect();
  _socket = null;
}

export function subscribeToCompany(companyId: string): void {
  getSocket().emit('subscribe:company', { companyId });
}

export function subscribeToTenant(tenantId: string): void {
  getSocket().emit('subscribe:tenant', { tenantId });
}

/** Navigation ping consumed by el gateway para presencia/historial (ver events.gateway.ts). */
export function emitActivity(path: string): void {
  const socket = getSocket();
  if (!socket.connected) return;
  socket.emit('activity', { path });
}
